import styled from 'styled-components'

export const PrintArea = styled.div`
  display: none;

  @media print {
    display: block;
  }
`
